import React from "react";
import timeTrailsEmpty from "../../../assets/timetrails/time_trails_empty.svg";
import "./NoRecord.css";
export const NoRecord = () => {
  return (
    <div className="noRecord">
      <img src={timeTrailsEmpty} alt="" />
      <h3 className="ftwt__r">No Records Found</h3>
    </div>
  );
};
